/**
 * @generated SignedSource<<c925f38fc3a3ca3f761e457c66298c15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCardForm_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ControlledAddressForm_viewer">;
  readonly " $fragmentType": "CheckoutCreditCardForm_viewer";
};
export type CheckoutCreditCardForm_viewer$key = {
  readonly " $data"?: CheckoutCreditCardForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCardForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ControlledAddressForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "74a5b7b72b1c5d5d95d26b6ddfeaac2d";

export default node;
